import { fetchFactory } from 'isotope-client'
import { RequestUpdateStockModel } from './stockModel'

export const updateStock = (centerType: string, values: RequestUpdateStockModel) => fetchFactory(`/${centerType}/stock`, {
    method: 'PUT',
    body: JSON.stringify(values)
})
